module.exports = new __parcel__URL__("pestulantdevastation.1cdee15b.png").toString();